var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showbox)?_c('div',[(_vm.showbox)?_c('div',[(_vm.noUser)?_c('NoUser'):_c('TaskList')],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }